import styled from "styled-components";


export const TextSectionContainer = styled.div`
    font-size:var(--sm-font-size);
`;
